import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface HelpAgentIconProps extends Omit<SvgIconProps, 'color'> {
    color?: string;
}

function HelpAgentIcon({ color = '#303030', ...props }: HelpAgentIconProps) {
    return (
        <SvgIcon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M12.4998 6C12.4998 4.61929 11.3805 3.5 9.99984 3.5C9.90779 3.5 9.83317 3.42538 9.83317 3.33333C9.83317 3.24129 9.90779 3.16667 9.99984 3.16667C11.3805 3.16667 12.4998 2.04738 12.4998 0.666667C12.4998 0.574619 12.5745 0.5 12.6665 0.5C12.7586 0.5 12.8332 0.574619 12.8332 0.666667C12.8332 2.04738 13.9525 3.16667 15.3332 3.16667C15.4252 3.16667 15.4998 3.24129 15.4998 3.33333C15.4998 3.42538 15.4252 3.5 15.3332 3.5C13.9525 3.5 12.8332 4.61929 12.8332 6C12.8332 6.09205 12.7586 6.16667 12.6665 6.16667C12.5745 6.16667 12.4998 6.09205 12.4998 6Z"
                fill={color}
            />
            <path
                d="M6.49984 14.6667C6.49984 11.8132 4.18664 9.5 1.33317 9.5C1.24112 9.5 1.1665 9.42538 1.1665 9.33333C1.1665 9.24129 1.24112 9.16667 1.33317 9.16667C4.18664 9.16667 6.49984 6.85347 6.49984 4C6.49984 3.90795 6.57446 3.83333 6.6665 3.83333C6.75855 3.83333 6.83317 3.90795 6.83317 4C6.83317 6.85347 9.14637 9.16667 11.9998 9.16667C12.0919 9.16667 12.1665 9.24129 12.1665 9.33333C12.1665 9.42538 12.0919 9.5 11.9998 9.5C9.14637 9.5 6.83317 11.8132 6.83317 14.6667C6.83317 14.7587 6.75855 14.8333 6.6665 14.8333C6.57446 14.8333 6.49984 14.7587 6.49984 14.6667Z"
                fill={color}
            />
        </SvgIcon>
    );
}

export default HelpAgentIcon;
